export default __webpack_public_path__ + "static/media/EstacoesIconNew.7df0bc5c.svg";